module.exports = __webpack_public_path__ + "static/media/GUIDE_0013_01.8fb80944.webp";